module.exports = __webpack_public_path__ + "static/img/photo-1574805240811-dff46ef88526.e5fa620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/photo-1574805240811-dff46ef88526.jpg
// module id = xvQR
// module chunks = 1